import React from 'react'
import PropTypes from 'prop-types'
import STYLE_CONSTANTS from '~/style/constants'

const ThreeDSLockIcon = ({ color, big }) => {
    const size = big ? 60 : 30

    return (
        <svg
            width={`${size}px`}
            height={`${size}px`}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
        >
            {/* Lock shackle */}
            <path
                d="M8 10V7a4 4 0 1 1 8 0v3"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {/* Lock body */}
            <rect
                x="5"
                y="10"
                width="14"
                height="10"
                rx="2"
                fill={color}
            />
            {/* Realistic keyhole */}
            <path
                d="M12 14.5
           c-0.552 0 -1 0.448 -1 1
           c0 0.552 0.448 1 1 1
           s1 -0.448 1 -1
           c0 -0.552 -0.448 -1 -1 -1z
           M11.5 16.5
           v1"
                fill="white"
                stroke="none"
            />
        </svg>
    )
}

ThreeDSLockIcon.defaultProps = {
    color: STYLE_CONSTANTS.colors.text.buttonGray,
    big: false
}

ThreeDSLockIcon.propTypes = {
    color: PropTypes.string,
    big: PropTypes.bool
}

export default ThreeDSLockIcon
